import { useState } from "react";

export interface ScopeOption {
  slug: string;
  label: string;
  href: string;
}

export interface ScopeMenuProps {
  options: ScopeOption[];
  currentSlug: string;
  /** Full-page navigation (the viewer owns a video element, a Leaflet map
   *  and an OfflineQueue — a scope hop is a clean teardown). */
  onNavigate: (href: string) => void;
}

/** Switch between annotation sets on one flight: the owner's own and each
 *  sub-client's (spec 2026-09-03 §6.3). Rendered only when the caller
 *  masters the owner's scope, so a sub-client never sees siblings. */
export function ScopeMenu({ options, currentSlug, onNavigate }: ScopeMenuProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const current = options.find((o) => o.slug === currentSlug);
  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        className="vmc-tbtn"
        data-tour="viewer.scope"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {`Annotations: ${current?.label ?? currentSlug} ▾`}
      </button>
      {open && (
        <div role="menu" className="vmc-export-menu">
          {options.map((o) => {
            const isCurrent = o.slug === currentSlug;
            return (
              <button
                key={o.slug}
                type="button"
                role="menuitemradio"
                aria-checked={isCurrent}
                disabled={isCurrent}
                className="vmc-export-menu-item"
                onClick={() => {
                  setOpen(false);
                  onNavigate(o.href);
                }}
              >
                {o.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
